import type { FilterExpression, FilterRule, FilterState } from '@/components/searchFilter/types'
import { isExpression } from '@/components/searchFilter/model'
import { toApiDate } from '@/utils/formatters'

/** Read old deep links alongside the new expression. Applying the panel clears legacy parameters. */
export function adverseSearchState(filters: Record<string, any>): FilterState {
  let expression: FilterExpression = { match: 'all', conditions: [] }
  if (filters.advanced) {
    try {
      expression = JSON.parse(filters.advanced)
    } catch {
      expression.conditions = [{ field: '$invalid', operator: 'eq', value: '' }]
    }
    if (!isExpression(expression)) {
      expression = { match: 'all', conditions: [{ field: '$invalid', operator: 'eq', value: '' }] }
    }
  }
  const rules: FilterRule[] = []
  for (const key of ['departments', 'event_types', 'coordinators', 'creators', 'status', 'risk']) {
    if (filters[key]?.length) rules.push({ field: key === 'risk' ? 'risk_level' : key, operator: 'in', value: filters[key].map(String) })
  }
  if (filters.numbers?.length) rules.push({ field: 'numbers', operator: 'in', value: filters.numbers.map(String) })
  for (const key of ['created_after', 'created_before']) {
    if (filters[key]) rules.push({ field: 'date_time', operator: key === 'created_after' ? 'gte' : 'lte', value: toApiDate(filters[key]) || '' })
  }
  for (const key of ['is_active', 'requires_action']) {
    if (typeof filters[key] === 'boolean' && (key !== 'is_active' || filters[key])) rules.push({ field: key, operator: 'in', value: [String(filters[key])] })
  }
  // Legacy links do not contain an expression. Mixed incoming links remain explicit, never silently broadened.
  if (rules.length && expression.match === 'any' && expression.conditions.length) {
    expression = { match: 'all', conditions: [{ field: '$mixed', operator: 'eq', value: 'Сбросьте смешанные условия ссылки и выберите фильтр заново' }, ...expression.conditions, ...rules] }
  } else expression.conditions.push(...rules)
  return { search: filters.search || '', filter: expression }
}
